<script setup lang="ts">
import OpenModalButton from '../OpenModalButton.vue'
</script>

<template>
  <OpenModalButton
    icon="users"
    title="Lineups"
  />
</template>
